import React, { CSSProperties, VFC } from 'react';
import classNames from 'classnames';
import {
    SmallMenuItemHeaderLinkSC,
    SmallMenuItemHeaderSC,
} from './SmallMenu.styled';
import Icon from 'components/icon/Icon';
import { useTranslation } from 'utils/localization';

interface Props {
    active: boolean;
    text: string;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    iconStyle: CSSProperties;
    link?: string;
}

const SmallMenuItemHeader: VFC<Props> = ({
    active,
    text,
    icon,
    iconStyle,
    link,
}) => {
    const { t } = useTranslation();

    if (link) {
        return (
            <SmallMenuItemHeaderLinkSC
                className={classNames({ active })}
                href={link}
                title={t(text)}
            >
                <Icon icon={icon} style={iconStyle} className="icon" />
                <div className="smallMenuText">{t(text)}</div>
            </SmallMenuItemHeaderLinkSC>
        );
    }

    return (
        <SmallMenuItemHeaderSC
            className={classNames({
                active,
            })}
        >
            <Icon icon={icon} style={iconStyle} className="icon" />
            <div className="smallMenuText">{t(text)}</div>
        </SmallMenuItemHeaderSC>
    );
};

export default SmallMenuItemHeader;
